const dateTimeRUFormatter = Intl.DateTimeFormat('ru-RU', { hour: '2-digit', minute: '2-digit' });
const dateTimeShortRUFormatter = Intl.DateTimeFormat('ru-RU');
const dateTimeShortestRUFormatter = Intl.DateTimeFormat('ru-RU', {
  day: '2-digit', month: '2-digit', year: '2-digit',
});

export const dateTimeRU = dateTimeRUFormatter.format;

export const dateTimeShortRU = dateTimeShortRUFormatter.format;

export const dateTimeShortestRU = dateTimeShortestRUFormatter.format;
